module.exports = __webpack_public_path__ + "static/easy-image-2-1-bdbfe7af9718b79503c32c771e450b60.jpg";